<template>
     <div class="container text-center g-pt-70">
      <h2 class="h1 mb-3">Looking for additional support?</h2>
      <p class="g-font-size-20">Check out these other programs from OneSight EssilorLuxottica Foundation to support your charitable work.</p>
      <div class="col-md-8 offset-md-2">
        <div class="row g-mb-30 justify-content-center">
          <div class="col-sm-6 col-lg-6 g-mb-30 home-page-invite">
            <a href="https://www.evfusa.org/get-involved/in-office-donation-campaigns/" target="_blank" class="no-underline g-color-main g-color-primary--hover" v-on:mouseover="HoverDonation('enter')" v-on:mouseleave="HoverDonation('leave')">
              <img class="img-fluid home-page-icon rounded-circle mx-auto g-mb-30 g-mt-30" :src="donationIcon" alt="Image Description" >
              <h3 class="h3">In-Office Donation Campaign</h3>
            </a>
            <div class="g-px-30--lg">
              <p class="g-color-text-light-v1 mb-0 g-font-size-20">Inspire patients and staff to adopt the cause of vision and raise funds.</p>
            </div>
          </div>
          <!-- <div class="col-sm-6 col-lg-6 g-mb-30 home-page-invite">
            <a href="http://www.aoafoundation.org/hehc" target="_blank" class="no-underline g-color-main g-color-primary--hover" v-on:mouseover="HoverCommunity('enter')" v-on:mouseleave="HoverCommunity('leave')">
              <img class="img-fluid home-page-icon rounded-circle mx-auto g-mb-30 g-mt-30" :src="communityIcon" alt="Image Description">
              <h3 class="h3">Community Grants</h3>
            </a>
            <div class="g-px-30--lg">
              <p class="g-color-text-light-v1 mb-0 g-font-size-20">EVF sponsors the AOA Foundation’s Healthy Eyes Healthy Children grant program where optometrists can apply for grants of up to $5,000.</p>
            </div>
          </div> -->
          <!-- <div class="col-sm-6 col-lg-4 g-mb-30">
          </div>
          <div class="col-sm-6 col-lg-3 g-mb-30">
          </div> -->
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      donationIcon: '../../../../static/assets/img/icons/Home Page Icons/money_inv.png',
      communityIcon: '../../../../static/assets/img/icons/Home Page Icons/hehc_inv.png'
    }
  },
  methods: {
    HoverDonation(event) {
      if(event == 'enter'){
        this.donationIcon = '../../../../static/assets/img/icons/Home Page Icons/money.png';
      }
      else if(event == 'leave'){
        this.donationIcon = '../../../../static/assets/img/icons/Home Page Icons/money_inv.png';
      }
    },
    HoverCommunity(event) {
      if(event == 'enter'){
        this.communityIcon = '../../../../static/assets/img/icons/Home Page Icons/path5119.png';
      }
      else if(event == 'leave'){
        this.communityIcon = '../../../../static/assets/img/icons/Home Page Icons/path5069.png';
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// HomeSupport.vue?5985003d